import { NgModule } from '@angular/core';
import { provideBootstrapEffects } from '@innogy/utils-state';
import { FehSharedApiStoreModule } from '@feh/shared-api';
import { EffectsModule } from '@ngrx/effects';

import { GenericFormEffects } from './generic-form/generic-form.effects';
import { GenericApiEffects } from './generic-form/api/generic.ngrx-wrapper';

@NgModule({
  imports: [
    FehSharedApiStoreModule,
    EffectsModule.forFeature(GenericApiEffects),
  ],
  providers: [provideBootstrapEffects([GenericFormEffects])],
})
export class SitecoreFormsStoreModule {}
